export type ContractStatusValue = "PENDING" | "ACTIVE" | "REJECTED" | "NIGO";

export const CONTRACT_STATUS_LABELS: Record<ContractStatusValue, string> = {
  PENDING: "Pending",
  ACTIVE: "Active",
  REJECTED: "Rejected",
  NIGO: "Needs attention",
};

export function normalizeContractStatus(value: string): ContractStatusValue {
  const upper = value.toUpperCase();
  if (upper === "ACTIVE" || upper === "REJECTED" || upper === "NIGO" || upper === "PENDING") {
    return upper;
  }
  return "PENDING";
}
